import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgLaptop({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 17a1 1 0 110 2H3a1 1 0 110-2h18zM18 4a3 3 0 012.995 2.824L21 7v5a3 3 0 01-2.824 2.995L18 15H6a3 3 0 01-2.995-2.824L3 12V7a3 3 0 012.824-2.995L6 4h12zm0 2H6a1 1 0 00-.993.883L5 7v5a1 1 0 00.883.993L6 13h12a1 1 0 00.993-.883L19 12V7a1 1 0 00-.883-.993L18 6z"
        fill={color}
      />
    </svg>
  )
}

export default SvgLaptop
